import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { IBreadCrumb } from 'src/app/forms/breadcrumb.interface';
@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent implements OnInit {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() bold: string;
  public breadcrumbs: IBreadCrumb[]
  
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
  }

  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd),distinctUntilChanged())
      .subscribe(() => this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root));
    window.scrollTo(0, 0);
  }

  redirect(){
    this.router.navigate(['/perfil/dashboard']);
  }

  buildBreadCrumb(route: ActivatedRoute, url: string = '', breadcrumbs: IBreadCrumb[] = []): IBreadCrumb[] {
    let label = route && route.routeConfig && route.routeConfig.data ? route.routeConfig.data.breadcrumb : '';
    let path = route && route.routeConfig && route.routeConfig.data ? route.routeConfig.path : '';

    const nextUrl = path ? `${url}/${path}` : `${path}`;
    const breadcrumb: IBreadCrumb = {
        label: label,
        url: `perfil/${nextUrl}`,
    };
    
    const newBreadcrumbs = breadcrumb.label ? [ ...breadcrumbs, breadcrumb ] : [ ...breadcrumbs];
    if (route && route.firstChild) {
        return this.buildBreadCrumb(route.firstChild, nextUrl, newBreadcrumbs);
    }
    return newBreadcrumbs;
  }
}
